import { useEffect } from 'react';
import { notification } from 'antd';


let eventSource: EventSource | null = null;

// 🔔 全局未读计数器逻辑（用于后续通知中心）
let unreadCount = 0;
let updateUnreadFn: ((count: number) => void) | null = null;

/**
 * 注册全局更新未读通知数量的函数（供通知图标组件调用）
 */
export const setUnreadUpdateHandler = (fn: (count: number) => void) => {
  updateUnreadFn = fn;
};

/**
 * 重置未读数量（可由通知弹窗点击清除）
 */
export const resetUnreadCount = () => {
  unreadCount = 0;
  updateUnreadFn?.(0);
};
declare global {
    interface Window {
    __refreshUnreadCount?: () => void;
  }
}

window.__refreshUnreadCount = async () => {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/sse/UnreadCount/Check?areaCode=${process.env.REACT_APP_CURRENT_LOCALITY}`);
  const json = await res.json();
  const count = json.data?.count ?? 0;
  window.__updateUnreadFromBell?.(count); // delta logic
};

export const useSSE = () => {
  useEffect(() => {
    const setupSSE = async () => {
      try {
        // Step 1. 获取本机 IP
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/sse/check-ip?areaCode=${process.env.REACT_APP_CURRENT_LOCALITY}`);
        const json = await res.json();
        if (!json.result?.success) return;

        const nestIp = json.data.nestIp;

        const unreadRes = await fetch(`${process.env.REACT_APP_BASE_URL}/sse/UnreadCount/Check?areaCode=${process.env.REACT_APP_CURRENT_LOCALITY}`);
        const unreadJson = await unreadRes.json();
        unreadCount = unreadJson.data.count ?? 0;
        updateUnreadFn?.(unreadCount);

        // Step 2. 已连接则跳过
        if (eventSource) {
          console.log('🟡 SSE already connected');
          return;
        }

        // Step 3. 建立连接
        eventSource = new EventSource(`${process.env.REACT_APP_BASE_URL}/notification/sse/${nestIp}/${process.env.REACT_APP_CURRENT_LOCALITY}`);

        eventSource.onopen = () => {
          console.log('✅ SSE connected');
          console.log(nestIp);
        };

        // Step 4. 接收消息
        eventSource.onmessage = (event) => {
          try {

            const wrapper = JSON.parse(event.data);
            const data = wrapper.data;

             if (data?.refresh === true) {
                    window.location.reload();
                    return;
             }

             const audio = new Audio('/notify.wav');
            audio.preload = 'auto';
            audio.load(); // optional preload to ensure ready
            audio.play().catch(err => {
              console.warn('🔇 Unable to play notification sound:', err);
            });

      
            if (Notification.permission === 'granted') {
              const systemNotify = new Notification(data.title, {
                body: data.message,
                icon: '/logo192.png',
              });
              systemNotify.onclick = () => {
                window.focus();
              };
            }

          
            notification.open({
              message: data.title,
              description: data.message,
              duration: 0,
            });

            window.__refreshNotificationList?.();
            window.__refreshNotificationDropdown?.();
            window.__refreshUnreadCount?.();
            
          } catch (err) {
            console.warn('⚠️ SSE message parse error', err);
          }
        };

        // Step 5. 自动重连机制
        eventSource.onerror = (err) => {
          console.error('❌ SSE error, attempting reconnect...', err);
          eventSource?.close();
          eventSource = null;
          setTimeout(setupSSE, 2000);
        };

        // Step 6. 第一次请求系统通知权限
        if (Notification.permission === 'default') {
          Notification.requestPermission().then((permission) => {
            console.log(`🔐 Notification permission: ${permission}`);
          });
        }
      } catch (err) {
        console.error('❌ SSE setup failed', err);
      }
    };

    setupSSE();

    return () => {
      eventSource?.close();
      eventSource = null;
    };
  }, []);
};
